// extracted by mini-css-extract-plugin
module.exports = {"fieldset":"DocsForm_fieldset__2KSpw","add_var_holder":"DocsForm_add_var_holder__2DMiL"};